module.exports = __webpack_public_path__ + "img/c010_3.8b7d3954.jpg";